import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetAllSearchResults } from "../../Config/API/search";
import SidebarEventCard from "../SidebarEventCard";
import NoData from "../cards/noData";

const ExploreEvents = () => {
  const [data, setData] = useState([]);

  const fetchEvents = async () => {
    const response = await GetAllSearchResults(
      {
        text: "",
        searchFor: "event",
        type: "",
        nameOfSports: "",
        location: "",
        registrationStatus: true
      },
      0,
      3
    );
    const data = await response.json();
    if (data?.type === "success") {
      if (data?.searchData?.length > 3) {
        data.searchData.length = 3;
      }
      setData(data.searchData);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  return (
    <Row className="sideItem" style={{ background: "transparent", boxShadow: "none" }}>
      <Col span={24}>
        <h1 className="timelineAboutpadding d-md-none">Explore Events</h1>
      </Col>
      {data.length ? (
        data.map((item) => {
          return <SidebarEventCard key={item._id} data={item} />;
        })
      ) : (
        <NoData noEvent />
      )}
      <Link to={"/player/search"} className="show-more">
        Show More
      </Link>
    </Row>
  );
};

export default ExploreEvents;
